import React, { useContext, useState } from 'react'
import { Button, TextField, Grid, Typography, Container, Paper } from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Assignment, Phone, PhoneDisabled } from "@material-ui/icons";

import { SocketContext} from "../SocketContext";

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    gridContainer: {
      width: '100%',
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
      },
    },
    container: {
      width: '600px',
      margin: '35px 0',
      padding: 0,
      [theme.breakpoints.down('xs')]: {
        width: '80%',
      },
    },
    margin: {
      marginTop: 20,
    },
    padding: {
      padding: 20,
    },
    paper: {
      padding: '10px 20px',
      border: '2px solid black',
    },
    callButton: {
      background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
      borderRadius: 3,
      border: 0,
      color: 'white',
      height: 48,
      padding: '0 30px',
      boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      marginTop: 20,
    },
    copyButton: {
      marginTop: 20,
      background: "linear-gradient(90deg, rgba(20,242,38,1) 0%, rgba(158,223,96,1) 21%, rgba(100,226,64,1) 35%, rgba(112,241,159,1) 100%)",
      borderRadius: 3,
      border: 0,
      color: 'white',
      height: 48,
      padding: '0 30px',
      boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      
    }
   }));


const Options = ({children}) => {
    const { me, callAccepted, name, setName, callEnded,leaveCall, callUser } = useContext(SocketContext);
    const [idToCall, setIdToCall] = useState('');
    const classes = useStyles();
    return (
        <Container className={classes.container}>
            <Paper elevation={10} className={classes.paper}>
                <form className={classes.root} noValidate autoComplete="off">
                    <Grid container className={classes.gridContainer}>
                        <Grid item xs={12} md={6} className={classes.padding}>
                            <Typography gutterBottom variant="h6">Account Info</Typography>
                            <TextField  label="Name" value={name} onChange={(e) => setName(e.target.value)} fullWidth />
                            {callAccepted && !callEnded ? (
                              <CopyToClipboard text={me} className={classes.copyButton}>
                                <Button variant="outlined" color="default" fullWidth disabled startIcon={<Assignment fontSize="large"/>}>
                                    Copy Your ID
                                </Button>
                                </CopyToClipboard>

                            
                            ):
                            (

                            <CopyToClipboard text={me} className={classes.copyButton}>
                                <Button variant="outlined" color="secondary" fullWidth startIcon={<Assignment fontSize="large"/>}>
                                    Copy Your ID
                                </Button>

                            </CopyToClipboard>

                            )
                            }
                        </Grid>
                        <Grid item xs={12} md={6} className={classes.padding}>
                            <Typography gutterBottom variant="h6">Make a call</Typography>
                            <TextField  label="ID To Call" value={idToCall} onChange={(e) => setIdToCall(e.target.value)} fullWidth />
                            {callAccepted && !callEnded ?(
                                <Button 
                                variant="contained" 
                                color="secondary" 
                                startIcon={<PhoneDisabled 
                                fontSize="large" />}
                                fullWidth
                                onClick={leaveCall}
                                className={classes.callButton}
                                >
                                    Hang Up
                                </Button>
                            ) : (
                                <Button
                                variant="contained" 
                                color="primary" 
                                startIcon={<Phone
                                fontSize="large" />}
                                fullWidth
                                onClick={() => callUser(idToCall)}
                                className={classes.callButton}
                                >
                                    Call
                                </Button>
                            )
                        }
                        </Grid>
                    </Grid>
                </form>
            {children}
            </Paper>
        </Container>
        
    )
}

export default Options;
